import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrackets1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrackets1"><Path d="M7.5 3.5H3.5V20.5H7.5M16.5 3.5H20.5V20.5H16.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBrackets1;
